"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = void 0;
var react_1 = __importDefault(require("react"));
var ButtonGroup = function ButtonGroup(props) {
  return react_1.default.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }, props.children);
};
exports.ButtonGroup = ButtonGroup;